import { Box } from "@mui/material";
import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { CMForm } from "../../components/common/Form/CMForm";
import { PageHeader } from '../../components/common/PageHeader/PageHeader';
import { formFields, validationSchema } from "./JobSchema";
import { addJob } from "../Jobs/JobServices";

export const JobAdd = () => {

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>

                    <Row>
                        <Col lg={12}>
                            <Box component="div" sx={{ mt: 2 }}>
                                <PageHeader header="Add Job" />
                                <CMForm
                                    validationSchema={validationSchema}
                                    formFields={formFields}
                                    addService={addJob}
                                    listPageKey='JOB_LIST'
                                />
                            </Box>
                        </Col>
                    </Row>

                </Container>
            </div>
        </React.Fragment>
    )
}
